<template>
    <html>
        <body>
            <h1>List of companies</h1>

            <div>
                <label for="companyName">Filter company name: </label>
                <input type="text" v-model="query" placeholder="name" />
            </div>
            <div>
                <label for="industry">Filter industry: </label>
                <select v-model="industry">
                    <option value="all" selected="selected">all</option>
                    <option value="transport">transport</option>
                    <option value="media">media</option>
                    <option value="technology">technology</option>
                </select>
            </div>
            <div>
                <label for="industry">Sort by: </label>
                <select v-model="sorting">
                    <option value="name" selected="selected">name</option>
                    <option value="marketCap">market cap</option>
                    <option value="shareValue">share price</option>
                    <option value="industry">industry</option>
                </select>
            </div>

            <div id="companies">
                <div class="company" v-for="company in displayedCompanies" v-bind:key="company.name">
                    <h2>{{ company.name }}</h2>
                    <span class="attr"><strong>Market cap:</strong> {{ formatNum(company.marketCap) }}</span>
                    <span class="attr"><strong>Share price:</strong> {{ company.shareValue }}</span>
                    <span class="attr"><strong>Stock Exchange:</strong> {{ company.exchange }}</span>
                    <span class="attr"><strong>Industry:</strong> {{ company.industry }}</span>
                </div>
            </div>
        </body>
    </html>
</template>

<script>
import CompanyData from './CompanyData';
export default {
    data: () => {
        return {
            query: "",
            industry: "all",
            sorting: "name"
        }
    },
    computed: {
        companies: () => CompanyData,
        displayedCompanies: function() {
            return CompanyData
                .filter((company) => {
                    return company.name.toLowerCase().match(this.query.toLowerCase())
                })
                .filter((company) => {
                    return (this.industry === "all" || company.industry === this.industry)
                })
                .sort((v1, v2) => {
                    if (v1[this.sorting] > v2[this.sorting]) return 1;
                    if (v1[this.sorting] < v2[this.sorting]) return -1;
                    return 0;
                });
        }
    },
    methods: {
        formatNum: function(num) {
            if (num > 10**12) {
                return `${(num / 10**12).toFixed(2)}T`
            }
            if (num > 10**9) {
                return `${(num / 10**9).toFixed(2)}B`
            }
            if (num > 10**6) {
                return `${(num / 10**6).toFixed(2)}M`
            }
            return num;
        }
    }
}
</script>

<style>
span.attr {
    display: block;
}

#companies {
    display: flex;
    flex-wrap: wrap;
}

.company {
    margin: 20px;
    width: 400px;
}

</style>